// 帮助方法
import CryptoJS from 'crypto-js'

export default {
  // 获取UTC日期的格式化字符串形式
  getUTCTime: function (formatString, date) {
    date = date || new Date()
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds(), // 毫秒
      T: date.getTime() // 总毫秒
    }
    if (/(y+)/.test(formatString)) { // 年
      formatString = formatString.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(formatString)) {
        formatString = formatString.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }
    return formatString
  },
  formatDateTime: function (val) {
    val = +val
    return !val ? '---' : this.getUTCTime('yyyy-MM-dd hh:mm:ss', new Date(val))
  },
  // 屏幕滚动
  scrollTop: (value) => {
    if (value) {
      document.documentElement.scrollTop = value
    } else {
      return document.documentElement.scrollTop
    }
  },
  // 手机号码验证
  phoneValid: (notRequired) => {
    return (rule, value, callback) => {
      const val = value.trim()
      const regExp = (/^[1][3456789]\d{9}$/)
      if (val === '' && !notRequired) {
        callback(new Error('请输入手机号码'))
      } else if (val && !regExp.test(val)) {
        callback(new Error('请正确输入手机号码'))
      } else {
        callback()
      }
    }
  },
  // 密码验证
  passwordValid: (message) => {
    return (rule, value, callback) => {
      const val = value.trim()
      // eslint-disable-next-line no-useless-escape
      const regExp = [/\d+/, /[a-z]+/, /[A-Z]+/, /[`~!@#$%^&*?=\-+_.,:''()<>|\/\[\]{}￥￡€ ]+/]
      const length = /\S{8,20}/
      let matches = 0
      regExp.forEach(item => {
        if (item.test(val)) {
          matches++
        }
      })
      if (val === '') {
        callback(new Error(message || '请输入密码'))
      } else if (matches < 3 || !length.test(val)) {
        callback(new Error('密码8-20位，至少包含数字，大写、小写和特殊字符中的三类'))
      } else {
        callback()
      }
    }
  },
  // 图形验证码验证
  captchaValid: (rule, value, callback) => {
    const val = value.trim()
    const regExp = (/^[0-9a-zA-Z]{4}$/)
    if (!val) {
      callback(new Error('请输入验证码'))
    } else if (!regExp.test(val)) {
      callback(new Error('验证码为4位数字或字母'))
    } else {
      callback()
    }
  },
  // md5加密
  md5: (val) => {
    return CryptoJS.MD5(val).toString()
  },
  // readFile
  readFile (file, resultType = 'dataUrl') {
    return new Promise((resolve) => {
      if (resultType === 'file') {
        resolve()
        return
      }
      const reader = new FileReader()
      reader.onload = (event) => {
        resolve(event.target.result)
      }
      if (resultType === 'dataUrl') {
        reader.readAsDataURL(file)
      } else if (resultType === 'text') {
        reader.readAsText(file)
      }
    })
  }
}
